import { Component, OnInit } from '@angular/core';
import { ConfigDataService } from '../../services/config-data.service';
import { ActivatedRoute } from '@angular/router';
import { Config } from '../../models/config.model';
import { StringUtilService } from '@core/services/string-util.service';

@Component({
  selector: 'app-config-list',
  templateUrl: './config-list.component.html',
  styleUrls: ['./config-list.component.scss']
})
export class ConfigListComponent implements OnInit {

  public configList: Config[] = [];
  public consumerKey: string;

  constructor(
    public configDataService: ConfigDataService,
    public stringUtil: StringUtilService,
    private route: ActivatedRoute
  ) {
    this.route.params.subscribe((params) => {
      this.consumerKey = this.stringUtil.decode(params.consumerKey);
      this.configDataService.getConfigsForConsumerKey({ consumerKey: this.consumerKey })
        .subscribe((configList) => {
          this.configList = configList;
        });
    });
  }

  ngOnInit(): void { }
}
